import axiosClient from 'api/axiosClient';
import PackageTransactionView from 'features/ManageInvestor/components/PackageTransactionView';
import KTBSCard from 'general/components/OtherKeenComponents/KTBSCard';
import AppConfigs from 'general/constants/AppConfigs';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

function InvestorGroupPackageListScreen() {
  const { user } = useSelector((state) => state.auth);
  const [filterPackageTransaction, setFilterPackageTransaction] = useState({
    page: 0,
    limit: AppConfigs.defaultPageLimit,
  });
  const [packageTransactionTotal, setPackageTransactionTotal] = useState(0);
  const [packageTransactionList, setPackageTransactionList] = useState([]);

  useEffect(() => {
    const getInvestmentPackageHistory = async (agencyId, filterPackageTransaction) => {
      const params = {
        agencyId: agencyId,
        ...filterPackageTransaction,
      };
      const res = await axiosClient.get('/investment', { params });
      const { result, investments, total } = res;
      if (result === 'success') {
        setPackageTransactionList(investments);
        setPackageTransactionTotal(total);
      }
    };
    if (user?.agency?.agencyId) getInvestmentPackageHistory(user?.agency?.agencyId, filterPackageTransaction);
  }, [user, filterPackageTransaction]);

  return (
    <KTBSCard
      borderRadius={10}
      body={
        user?.agency?.agencyId && (
          <PackageTransactionView
            showFullUI={true}
            agencyId={user?.agency?.agencyId}
            packageTransactionList={packageTransactionList}
            packageTransactionTotal={packageTransactionTotal}
            filter={filterPackageTransaction}
            onFilterChanged={(filter) => {
              setFilterPackageTransaction({
                ...filterPackageTransaction,
                ...filter,
              });
            }}
          />
        )
      }
    />
  );
}

export default InvestorGroupPackageListScreen;
